import clsx from 'clsx';

import type { Adaptive } from '../types/Adaptive';

export function composeGridColumnsClasses(columns: Adaptive<number>): string {
    if (typeof columns === 'object') {
        return clsx(
            columns.base && `grid-cols-${columns.base}`,
            columns.sm && `sm:grid-cols-${columns.sm}`,
            columns.md && `md:grid-cols-${columns.md}`,
            columns.lg && `lg:grid-cols-${columns.lg}`,
            columns.xl && `xl:grid-cols-${columns.xl}`,
            columns['2xl'] && `2xl:grid-cols-${columns['2xl']}`
        );
    }

    return `grid-cols-${columns}`;
}
